import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import axios from 'axios';
import Popup from 'reactjs-popup';
import Header from '../../../Components/V2/Header';
import Footer from '../../../Components/V2/Footer';
import './style.scss';
export default class UpdateClients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registers: [],
      popup: false,
      message: '',
    };
    this.inputRef = React.createRef();
    this.userRef = React.createRef();
    this.tryRef = React.createRef();
    this.noteRef = React.createRef();
  }

  componentDidMount() {
    axios.get('/api/v1/platform/registers/direct').then(({ data }) => {
      if (data.success) {
        this.setState({
          registers: data.payload.registers,
        });
      }
    });
  }

  checkValidNumber = (num) => {
    if (!num || num <= 0 || num > 100000000) {
      return false;
    }
    return true;
  };

  save = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const count = this.inputRef.current.value;
    const sme = this.userRef.current.value;
    const tryCount = this.tryRef.current.value;
    if (
      (count && !this.checkValidNumber(count)) ||
      (sme && !this.checkValidNumber(sme)) ||
      (tryCount && !this.checkValidNumber(tryCount))
    ) {
      return;
    }
    if (!count && !sme && !tryCount) {
      return;
    }
    this.setState({ popup: true, message: 'Đang tải...' });
    axios
      .post('/api/v1/platform/registers/direct', {
        reach: count,
        sme: sme,
        user: tryCount,
        note: this.noteRef.current.value,
      })
      .then(({ data }) => {
        if (data.success) {
          this.inputRef.current.value = '';
          this.setState({
            registers: data.payload.registers,
            // popup: false,
            message: 'Thêm vào thành công.',
          });
        } else {
          this.setState({
            message: 'Xảy ra lỗi! Vui lòng thử lại sau.',
          });
        }
      });
    return false;
  };

  closeModal = () => {
    this.setState({ popup: false });
  };

  render() {
    const { registers, popup, message } = this.state;
    return (
      <CookiesProvider>
        <Popup open={popup} closeOnDocumentClick onClose={this.closeModal}>
          <div class='row justify-content-center'>
            <div class='col-xl-12 col-md-10'>
              <div class='p-30 background-white border-radius-5'>
                <div
                  class='justify-content-center padding_eight_all bg-white'
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <div class='heading_s1'>
                    <h3 class='mb-30'>{message}</h3>
                  </div>
                  <div class='form-group col-6'>
                    <button
                      type='submit'
                      class='btn btn-fill-out btn-block'
                      onClick={this.closeModal}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        <div className='category-page'>
          <Header />
          {/* <main className='main_content sidebar_right pb-50'> */}
          <main className='position-relative'>
            <div class='archive-header shop-header header-bg2 pt-20 pb-20 mb-80'>
              <div class='container'>
                <div class='row align-items-center h-30'>
                  <div class='col-md-6 mx-auto'>
                    <h3>
                      <span class='color6'>
                        Báo cáo số lượng SME chuyển đổi số
                      </span>
                    </h3>
                  </div>
                  <div class='col-md-6 mx-auto text-center text-md-right'></div>
                </div>
              </div>
            </div>
            <div class='main_content shop shopping-cart pb-50'>
              <div class='container'>
                <div class='row mb-50'>
                  <div class='col-lg-6 col-md-12'>
                    <div class='heading_s1 mb-3'>
                      <h6>Thêm báo cáo mới</h6>
                      <span>*Nhập tối thiểu 1 trong 3 thông tin sau</span>
                    </div>
                    <form class='field_form shipping_calculator'>
                      <div class='form-row'>
                        <div class='form-group col-lg-6'>
                          <input
                            required='required'
                            placeholder='Số lượng SME tiếp cận nền tảng'
                            class='form-control'
                            name='user'
                            type='number'
                            ref={this.inputRef}
                          />
                        </div>
                        <div class='form-group col-lg-6'>
                          <input
                            required='required'
                            placeholder='Số lượng SME sử dụng nền tảng'
                            class='form-control'
                            name='user'
                            type='number'
                            ref={this.userRef}
                          />
                        </div>
                      </div>
                      <div class='form-row'>
                        <div class='form-group col-lg-6'>
                          <input
                            required='required'
                            placeholder='Số người sử dụng nền tảng'
                            class='form-control'
                            name='user'
                            type='number'
                            ref={this.tryRef}
                          />
                        </div>
                      </div>
                      <div class='form-row'>
                        <div class='form-group col-lg-12'>
                          <div class='divider mt-10 mb-10'></div>
                        </div>
                        <div class='form-group col-lg-6'>
                          <input
                            required='required'
                            placeholder='Ghi chú bổ sung'
                            class='form-control'
                            name='user'
                            type='text'
                            ref={this.noteRef}
                          />
                        </div>
                      </div>
                      <div class='form-row'>
                        <div class='form-group col-lg-12'>
                          <button
                            class='btn btn-dark btn-fill-line'
                            onClick={(e) => this.save(e)}
                          >
                            Lưu
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class='divider center_icon mt-50 mb-50'></div>
                <div class='row'>
                  <div class='col-12'>
                    <div class='table-responsive'>
                      <table class='table shopping-summery shop_cart_table'>
                        <thead>
                          <tr class='main-hading'>
                            <th>Số lượng SME tiếp cận nền tảng</th>
                            <th>Số lượng SME sử dụng nền tảng</th>
                            <th>Số người sử dụng nền tảng</th>
                            <th>Ghi chú bổ sung</th>
                            <th>Ngày thêm</th>
                          </tr>
                        </thead>
                        <tbody>
                          {registers.map((item) => (
                            <tr>
                              <td class='product-des product-name'>
                                {item.reach}
                              </td>
                              <td class='product-des product-name'>
                                {item.sme}
                              </td>
                              <td class='product-des product-name'>
                                {item.user}
                              </td>
                              <td class='product-des product-name'>
                                {item.note}
                              </td>
                              <td class='price' data-title='Price'>
                                <span>{item.created_at}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
